import styled from 'styled-components';

import {Device} from '../../../constants';

const StyledCtaDescription = styled.div`
  width: 100%;
  margin: 0 auto;
  color: #fff;
  font-size: 1.4em;
  margin-bottom: 1em;
  padding: 1em;
  margin: 1em 0;

  &&&& {
    p {
      margin: 0;
      line-height: 1.7;
      font-style: italic;
    }
  }

  @media screen and ${Device.laptopL} {
    width: 100%;
    margin-bottom: 0;
    padding: 0;
  }

  @media screen and ${Device.tablet} {
    width: 100%;
  }

  @media screen and ${Device.mobileL} {
    width: 100%;
    font-size: 1em;
    margin: 0;
    margin-top: 1em;
  }
`;

export default StyledCtaDescription;
